

import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { useAuth } from '../../auth/Auth';
import {
  Card,
  Grid,
  Icon,
  IconButton,
  Tooltip,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import DataTable from "examples/Tables/DataTable";
import { FaFileCsv } from "react-icons/fa";
import { useTheme } from "@mui/material/styles";
import { handleExportCSV } from 'components/ExportUtils';
import QuotationModal from 'components/CustomModals/AddQuotationModal'; // Adjust the path as necessary
import { formatDate } from 'utils/DateTimeConversion';
import EmailModal from 'components/EmailModal';
import useOpenCreateFromUrl from "hooks/useOpenCreateFromUrl";
import PageHeader from "components/v2/PageHeader";
import { useActiveApp } from "shell-v2/apps";

function Quotation() {


  const [quotations, setQuotations] = useState([]);
  // UI v2 layout (design-reference "Travel · Bookings list"): page header,
  // then the table in one card.
  const isV2 = useTheme()?.pearlUi === 'v2';
  const { app } = useActiveApp();
  const quotationsLabel = app?.labels?.quotation || 'Quotations';
  const navigate = useNavigate();
  const { axiosInstance } = useAuth();
  const theme = useTheme();
  const [isQuotationModalOpen, setIsQuotationModalOpen] = useState(false);
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [newEmail, setNewEmail] = useState('');
  const [emailContext, setEmailContext] = useState('');
  const [isGenerating, setIsGenerating] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showCc, setShowCc] = useState(false);
  const [showBcc, setShowBcc] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleCreateNewQuotation = () => {
    setIsQuotationModalOpen(true); // Open the modal
  };
  // v2 header "New quotation": the same dialog as Add Quotation.
  useOpenCreateFromUrl(handleCreateNewQuotation);

  const [newQuotation, setNewQuotation] = useState({
    deal_id: id,
    total_amount: 0,
    status: 'Sent',
  })

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });
  const fetchQuotations = async () => {
    try {
      // setQuotations(demoQuotations); // TO BE REMOVED

      const response = await axiosInstance.get(`/quotations/`);
      console.log(`Quotations: ${JSON.stringify(response.data)}`);

      setQuotations(response.data);

    } catch (error) {
      console.error('Error fetching quotations data:', error);
    }
  };
  const handleSendEmail = (id) => {
    console.log(`Sending email for quotation ${id}`);
    // Set any necessary data for the email modal
    setNewEmail(`Quotation ID: ${id}`); // Example of setting the new email content
    setIsEmailModalOpen(true); // Open the email modal
  };

 // Define the toggle function for the email modal
 const handleToggleEmailModal = () => {
  setIsEmailModalOpen(!isEmailModalOpen);
};

// Define the function to handle sending the email
const handleSend = async () => {
  // Implement your email sending logic here
  console.log("Sending email:", newEmail);
  // After sending, you might want to close the modal
  setIsEmailModalOpen(false);
};

// Define the function to generate email content
const handleGenerateEmail = () => {
  // Implement your logic to generate email content
  console.log("Generating email content");
};

// Define the toggle functions for CC and BCC
const toggleCc = () => {
  setShowCc(!showCc);
};

const toggleBcc = () => {
  setShowBcc(!showBcc);
};

// Define the function to handle changes in the email editor
const handleQuillChange = (value) => {
  setEmailContext(value);
};

// Define modules and formats for the email editor (if using a rich text editor)
const modules = {
  toolbar: [
    [{ 'header': [1, 2, false] }],
    ['bold', 'italic', 'underline'],
    ['link', 'image'],
    ['clean']                                         // remove formatting button
  ],
};

const formats = [
  'header', 'bold', 'italic', 'underline', 'link', 'image'
];

  useEffect(() => {
    fetchQuotations();
  }, []);

  // const handleSendEmail = (id) => {
  //   console.log(`Sending email for quotation ${id}`);
  //   // Implement email sending logic here
  // };

  const handleDownloadPDF = (id) => {
    console.log(`Downloading PDF for quotation ${id}`);
    // Implement PDF download logic here
  };

  const handleDownloadCSV = () => {
    handleExportCSV();
    console.log(`Downloading CSV for quotation ${id}`);
  }

  const handleRowClick = (rowData) => {
    navigate(`/quote/${rowData.id}`);
  };


  const handleSaveQuotation = async (data) => {
    // Prepare the tax slabs and amounts from the tax summary
    const taxSummary = data.tax_summary || [];
    const taxSlabs = taxSummary.map(item => item.taxRate); // Extract tax rates (e.g., [5, 10, 18])
    const taxAmounts = taxSummary.map(item => item.amount); // Extract tax amounts (e.g., [1223, 456, 789])

    // Prepare the main quotation data with tax slabs and amounts
    const quotationData = {
      deal_id: id, // Assuming 'id' is the deal ID for the quotation
      quote_name: data.quote_name, // Include deal name
      total_amount: data.total_amount,
      grand_total: data.total_amount,
      status: data.status,
      notes: data.notes,
      shipping_method: data.shipping_method,
      payment_methods: data.payment_methods,
      tax: data.tax,
      delivery_date: data.delivery_date || null,
      subtotal: data.subtotal, // Include subtotal
      // Add tax slabs and amounts directly into the quotation data
      tax_slab_1: data.tax_slab_1 || taxSlabs[0] || null,
      tax_slab_2: data.tax_slab_2 || taxSlabs[1] || null,
      tax_slab_3: data.tax_slab_3 || taxSlabs[2] || null,
      tax_slab_4: data.tax_slab_4 || taxSlabs[3] || null,
      tax_slab_5: data.tax_slab_5 || taxSlabs[4] || null,
      tax_slab_amount_1: data.tax_slab_amount_1 || taxAmounts[0] || null,
      tax_slab_amount_2: data.tax_slab_amount_2 || taxAmounts[1] || null,
      tax_slab_amount_3: data.tax_slab_amount_3 || taxAmounts[2] || null,
      tax_slab_amount_4: data.tax_slab_amount_4 || taxAmounts[3] || null,
      tax_slab_amount_5: data.tax_slab_amount_5 || taxAmounts[4] || null,
    };

    console.log('New Quotation:', quotationData);
    console.log('Quotation Items before modification:', data.items);

    setIsLoading(true);
    handleCloseQuotationModal();

    try {
      // Create the quotation
      const quotationResponse = await axiosInstance.post('/quotations/', quotationData);

      const newQuotationId = quotationResponse.data.id;

      // Add quotation_id to each item
      const quotationItems = data.items.map((item) => ({
        ...item,
        quotation_id: newQuotationId,
      }));

      console.log('Quotation Items after modification:', quotationItems);

      // Create the quotation items
      await axiosInstance.post(`/quotations/${newQuotationId}/items`, quotationItems);

      // Fetch the updated quotation with items
      const updatedQuotationResponse = await axiosInstance.get(`/quotations/${newQuotationId}`);

      setQuotations((prevQuotations) => [...prevQuotations, updatedQuotationResponse.data]);
      setSnackbar({
        open: true,
        message: 'Quotation created successfully!',
        severity: 'success',
      });
    } catch (error) {
      console.error('Error saving quotation:', error);
      setSnackbar({
        open: true,
        message: `Error saving quotation: ${error.message}`,
        severity: 'error',
      });
    } finally {
      setIsLoading(false);
    }
  };
  const handleCloseQuotationModal = () => {
    setIsQuotationModalOpen(false);
    setNewQuotation({
      deal_id: id,
      total_amount: '',
    })
  }
  // const handleCreateNewQuotation = () => {
  //   navigate('/quotation/new');
  // };

  const quotationTableData = {
    columns: [
      {
        Header: "Quote",
        accessor: "quote_name",
        width: "25%",
        Cell: ({ value, row }) => (
          <MDTypography
            component="a"
            href="#"
            variant="caption"
            color="text"
            fontWeight="medium"
            sx={{ cursor: 'pointer' }}
            onClick={() => handleRowClick(row.original)}
          >
            {value}
          </MDTypography>
        )
      },
      {
        Header: "Account",
        accessor: "account_name",
        width: "25%",
        Cell: ({ value, row }) => (
          <MDTypography
            component="a"
            href="#"
            variant="caption"
            color="info"
            fontWeight="medium"
            sx={{ cursor: 'pointer' }}
            onClick={() => navigate(`/accounts/details/${row.original.id}`)} // Redirect to the account details page
          >
            {value}
          </MDTypography>
        )
      },
      { Header: "Amount", accessor: "total_amount", width: "20%" },
      {
        Header: "Status",
        accessor: "status",
        width: "20%",
        Cell: ({ value }) => {

          let color;
          switch (value.toLowerCase()) {
            case 'sent':
              color = 'info';
              break;
            case 'draft':
              color = 'warning';
              break;
            case 'accepted':
              color = 'success';
              break;
            case 'rejected':
              color = 'error';
              break;
            default:
              color = 'default';
          }
          return (
            <MDTypography
              component="span"
              variant="caption"
              color="white"
              fontWeight="medium"
              sx={{
                backgroundColor: (theme) => theme.palette[color].main,
                padding: '4px 8px',
                borderRadius: '4px',
              }}
            >
              {value}
            </MDTypography>
          );
        }
      },
      {
        Header: "Created Date",
        accessor: "created_at", // Assuming this is the date field you want to format
        width: "20%",
        Cell: ({ value }) => formatDate(value) // Format the date using formatDate
      },
      {
        Header: "Actions",
        accessor: "actions",
        width: "15%",
        Cell: ({ row }) => (
          <MDBox display="flex" justifyContent="space-around">
            <Tooltip title="Send Email">
              <IconButton onClick={() => handleSendEmail(row.original.id)} color="info" size="medium">
                <Icon>email</Icon>
              </IconButton>
            </Tooltip>
            <Tooltip title="Download PDF">
              <IconButton onClick={() => handleDownloadPDF(row.original.id)} color="info" size="medium">
                <Icon>picture_as_pdf</Icon>
              </IconButton>
            </Tooltip>
            <Tooltip title="Download CSV">
              <IconButton >
                <FaFileCsv style={{ color: theme.palette.info.main }} size={23} />
              </IconButton>
            </Tooltip>
          </MDBox>
        ),
      },
    ],
    rows: quotations,
  };

  // Shared by the classic and v2 layouts below: the same actions and table.
  const listActions = (
    <>
      <MDButton
        variant="gradient"
        color="dark"
        onClick={handleCreateNewQuotation}
        sx={{ marginRight: 2 }}
      >
        <Icon sx={{ fontWeight: "bold" }}>add</Icon>
        &nbsp;Add Quotation
      </MDButton>
      <MDButton
        component={Link}
        to="/reports"
        variant="gradient"
        color="light"
      >
        <Icon sx={{ fontWeight: "bold" }}>assessment</Icon>
        &nbsp;Reports
      </MDButton>
    </>
  );
  const listBody = (
    <>
      <DataTable
        table={quotationTableData}
        isSorted={true}
        entriesPerPage={true}
        showTotalEntries={true}
        noEndBorder
        canSearch
        searchPlaceholder="Search for quotations..."
        pagination={{ variant: "gradient", color: "info" }}
        exportCSV={true}
        objectType="quotation"
        onFilterClear={() => fetchQuotations()}
      />
    </>
  );

  const v2Main = (
    <MDBox>
      <PageHeader title={quotationsLabel} summary={isLoading ? null : `${quotations.length} ${quotations.length === 1 ? "quotation" : quotationsLabel.toLowerCase()}`} actions={listActions} />
      <Card>
        <MDBox pt={1}>{listBody}</MDBox>
      </Card>
    </MDBox>
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {isV2 ? v2Main : (
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDBox display="flex" justifyContent="space-between" alignItems="center" width="100%">
                  <MDTypography variant="h6" color="white">
                    Recent Quotations
                  </MDTypography>
                  <MDBox>
                    {listActions}
                  </MDBox>
                </MDBox>
              </MDBox>
              <MDBox pt={3}>
                {listBody}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      )}
      <EmailModal
        open={isEmailModalOpen}
        onClose={handleToggleEmailModal}
        newEmail={newEmail}
        setNewEmail={setNewEmail}
        handleSend={handleSend}
        isGenerating={isGenerating}
        errorMessage={errorMessage}
        emailContext={emailContext}
        setEmailContext={setEmailContext}
        handleGenerateEmail={handleGenerateEmail}
        showCc={showCc}
        showBcc={showBcc}
        toggleCc={toggleCc}
        toggleBcc={toggleBcc}
        handleQuillChange={handleQuillChange}
        modules={modules}
        formats={formats}
        loading={loading}
      />
      <QuotationModal
        isOpen={isQuotationModalOpen}
        onClose={() => setIsQuotationModalOpen(false)} // Close the modal
        onSave={handleSaveQuotation} // Pass the save function if needed
      />
      
    </DashboardLayout>
  );
}

export default Quotation;

